export const en = {
  locationLine: "Levy Santiago, Bahia, Brazil",
};
